/* "Complete the look" — Add without leaving the bag.

   The list itself is rendered server-side from the collection chosen in the
   Cart drawer settings. This file only handles the Add button: it posts to
   /cart/add.js asking for the drawer's own sections back, then hands them to
   the drawer's renderContents() so the cart updates in place. No reload, and
   the drawer stays open. */
(function () {
  function sectionsFor(drawer) {
    try {
      return drawer.getSectionsToRender().map(function (s) { return s.id; });
    } catch (e) {
      return ['cart-drawer', 'cart-icon-bubble'];
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mdm-dr-add');
    if (!btn) return;
    e.preventDefault();

    var drawer = document.querySelector('cart-drawer');
    var variant = parseInt(btn.dataset.variant, 10);
    if (!drawer || !variant) return;

    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variant, quantity: 1 }],
        sections: sectionsFor(drawer),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state && state.sections) {
          drawer.renderContents(state);
          /* renderContents can close the drawer on some paths — keep it open. */
          if (typeof drawer.open === 'function' && !drawer.classList.contains('active')) drawer.open();
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  });
})();
